/**
 * 全局自定义指令配置
 */
import Vue from 'vue'
// import permission from '@/directive/permission'
import defaultImg from '@/directive/defaultImg'

// Vue.directive('permission', permission)
Vue.directive('defaultImg', defaultImg)
